import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    quizContentContainer: {
        maxWidth: "658px",
        width: "100%"
    }
})
export const QuizWelcomeContainer = ({children}) => {
    const classes = useStyles()
    return (
        <div
            className={classes.quizContentContainer}
        >
            {children}
        </div>
    )
}